var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "generateSelectedTopic" },
    [
      !_vm.obj.isHistory
        ? [
            _c(
              "div",
              { staticClass: "item" },
              [
                _c("div", { staticClass: "lable" }, [_vm._v("选题字数：")]),
                _c("el-input", {
                  staticStyle: { "font-size": "14px" },
                  attrs: {
                    disabled: _vm.obj.status > 0,
                    placeholder: "请输入内容",
                  },
                  model: {
                    value: _vm.input,
                    callback: function ($$v) {
                      _vm.input = _vm._n($$v)
                    },
                    expression: "input",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item" },
              [
                _c("div", { staticClass: "lable" }, [_vm._v("IP老师：")]),
                _c(
                  "el-select",
                  {
                    staticClass: "select-teacher",
                    staticStyle: { "font-size": "14px" },
                    attrs: {
                      multiple: "",
                      disabled: _vm.obj.status > 0,
                      filterable: "",
                      clearable: "",
                      remote: "",
                      "remote-method": _vm.teacherQueryByName,
                      "popper-append-to-body": false,
                      placeholder: "请选择",
                    },
                    model: {
                      value: _vm.value1,
                      callback: function ($$v) {
                        _vm.value1 = $$v
                      },
                      expression: "value1",
                    },
                  },
                  _vm._l(_vm.options, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "item flex-top" },
              [
                _c(
                  "div",
                  { staticClass: "lable", staticStyle: { width: "88px" } },
                  [_vm._v("选题模版：")]
                ),
                _c("el-input", {
                  staticStyle: { "font-size": "14px" },
                  attrs: {
                    type: "textarea",
                    rows: 6,
                    disabled: _vm.obj.status > 0,
                    maxlength: "2000",
                    "show-word-limit": "",
                    resize: "none",
                    placeholder: "请输入内容",
                  },
                  model: {
                    value: _vm.textarea,
                    callback: function ($$v) {
                      _vm.textarea = $$v
                    },
                    expression: "textarea",
                  },
                }),
              ],
              1
            ),
            _vm.obj.status === 0
              ? _c("div", { staticClass: "bottom-operate" }, [
                  _c("div", { staticClass: "flex flex-middle" }, [
                    _c(
                      "div",
                      {
                        staticClass: "float-bottom",
                        on: { click: _vm.submit },
                      },
                      [
                        _c("img", {
                          staticClass: "img-default",
                          attrs: {
                            src: require("@/assets/image/aigc/qdsc.png"),
                            alt: "",
                          },
                        }),
                        _c("span", { staticClass: "title-span" }, [
                          _vm._v(" 确定生成 "),
                        ]),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "close",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.close.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "img-default",
                          attrs: {
                            src: require("@/assets/image/aigc/close-qxsc.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" 取消生成"),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "float-bottom2",
                      on: {
                        click: function ($event) {
                          _vm.isSelectedTopicTemplate = true
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "img-default",
                        attrs: {
                          src: require("@/assets/image/aigc/xzmb.png"),
                          alt: "",
                        },
                      }),
                      _c(
                        "span",
                        { staticClass: "title-span title-span-reset" },
                        [_vm._v(" 选题参考模板")]
                      ),
                      _vm.isSelectedTopicTemplate
                        ? _c("SelectedTopicTemplate", {
                            ref: "selectedTopicTemplateRef",
                            on: {
                              selectItem: _vm.handleSelectItem,
                              handleClose: function ($event) {
                                _vm.isSelectedTopicTemplate = false
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.obj.status > 0
        ? [
            _c("el-divider"),
            _c("div", { staticClass: "xt-Content" }, [
              _c(
                "div",
                { staticClass: "selectedTopicContent" },
                [_c("VueMarkdown", { attrs: { source: _vm.content } })],
                1
              ),
              _c("div", { staticClass: "bottom-operate" }, [
                !_vm.obj.isHistory && _vm.isEnd
                  ? _c(
                      "div",
                      {
                        staticClass: "float-bottom",
                        on: { click: _vm.regeneration },
                      },
                      [
                        _c("img", {
                          staticClass: "img-default",
                          attrs: {
                            src: require("@/assets/image/aigc/reset-cxsc.png"),
                            alt: "",
                          },
                        }),
                        _c("span", { staticClass: "title-span" }, [
                          _vm._v("重新生成"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.obj.isHistory || !_vm.isEnd ? _c("div") : _vm._e(),
                _vm.isEnd || _vm.obj.isHistory
                  ? _c(
                      "div",
                      {
                        staticClass: "float-bottom-right",
                        on: { click: _vm.copyText },
                      },
                      [
                        _c("img", {
                          staticClass: "img-default",
                          attrs: {
                            src: require("@/assets/image/aigc/copy.png"),
                            alt: "",
                          },
                        }),
                        _c("div", { staticClass: "tip" }, [_vm._v("复制")]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }